/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_WalletInputs */

const en_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Wallet`)
};

const es_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartera Sovereign`)
};

const fr_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portefeuille Sovereign`)
};

const de_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign-Wallet`)
};

const ja_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign ウォレット`)
};

const zh_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 钱包`)
};

const ar_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محفظة Sovereign`)
};

const id_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dompet Sovereign`)
};

const it_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portafoglio Sovereign`)
};

const ru_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кошелек Sovereign`)
};

const pt_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carteira Sovereign`)
};

const ko_sovereign_wallet = /** @type {(inputs: Sovereign_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 지갑`)
};

/**
* | output |
* | --- |
* | "Sovereign Wallet" |
*
* @param {Sovereign_WalletInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_wallet = /** @type {((inputs?: Sovereign_WalletInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_WalletInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_wallet(inputs)
	if (locale === "es") return es_sovereign_wallet(inputs)
	if (locale === "fr") return fr_sovereign_wallet(inputs)
	if (locale === "de") return de_sovereign_wallet(inputs)
	if (locale === "ja") return ja_sovereign_wallet(inputs)
	if (locale === "zh") return zh_sovereign_wallet(inputs)
	if (locale === "ar") return ar_sovereign_wallet(inputs)
	if (locale === "id") return id_sovereign_wallet(inputs)
	if (locale === "it") return it_sovereign_wallet(inputs)
	if (locale === "ru") return ru_sovereign_wallet(inputs)
	if (locale === "pt") return pt_sovereign_wallet(inputs)
	return ko_sovereign_wallet(inputs)
});